import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeleportComponent } from './teleport.component';
import { TeleportDirective } from "./teleport.directive";


@NgModule({
  declarations: [
    TeleportComponent,
    TeleportDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TeleportComponent,
    TeleportDirective
  ],
})
export class TeleportModule { }
